/**
 * Represents the supported values for an operation status result.
 *
 * @type {Object<string>}
 */
const OperationStatus = {
    SUCCESS: 'success',
    FAILED: 'failed'
};

export default OperationStatus;
